import { jsx } from "react/jsx-runtime";
import { RateSummary } from "@zillow/zhl-rate-card";
import "react";
const RateSummaryBlock = {
  Component: ({
    attrs,
    blockData
  }) => {
    return /* @__PURE__ */ jsx(RateSummary, { ...blockData, ...attrs });
  },
  metadata: {
    name: "zhl/zhl-rate-summary",
    title: "ZHL Rate Summary",
    description: "ZHL Rate Summary",
    icon: "editor-table",
    category: "more",
    keywords: ["zhl", "loan", "rate", "summary"],
    attributes: {
      state: {
        type: "string",
        control: "text",
        default: "CA",
        description: "State to fetch rates for, use two letter abbreviation",
        label: "State"
      },
      principal: {
        type: "number",
        control: "number",
        default: 275e3,
        description: "Principal amount to calculate rates for",
        label: "Principal"
      },
      loanOption: {
        type: "string",
        control: "select",
        default: "Default",
        label: "Loan Option",
        description: "Select the loan type to display",
        choices: [{
          value: "Default",
          label: "Default"
        }, {
          value: "30 Year Fixed Conforming",
          label: "30 Year Fixed Conforming"
        }, {
          value: "30 Year FHA",
          label: "30 Year FHA"
        }, {
          value: "30 Year VA",
          label: "30 Year VA"
        }, {
          value: "20 Year Fixed Conforming",
          label: "20 Year Fixed Conforming"
        }, {
          value: "15 Year Fixed Conforming",
          label: "15 Year Fixed Conforming"
        }, {
          value: "25 Year FHA",
          label: "25 Year FHA"
        }, {
          value: "20 Year FHA",
          label: "20 Year FHA"
        }, {
          value: "10 Year Fixed Conforming",
          label: "10 Year Fixed Conforming"
        }, {
          value: "30 Year Jumbo (Non Conforming)",
          label: "30 Year Jumbo (Non Conforming)"
        }, {
          value: "7/6 ARM Conforming",
          label: "7/6 ARM Conforming"
        }]
      }
    }
  },
  getBlockData: async ({
    attrs
  }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    const principal = (attrs == null ? void 0 : attrs.principal) || 275e3;
    const state = (attrs == null ? void 0 : attrs.state) || null;
    const apiUrl = process.env.ZHL_RATES_API_URL + `/zhlRatePage/states/${state || "CA"}`;
    const apiKey = process.env.ZHL_RATES_API_KEY;
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: {
          apiKey
        }
      });
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      const transformedData = {
        state,
        data,
        principal,
        thirtyYearRate: (_a = data["30 Year Fixed Conforming"]) == null ? void 0 : _a.rate,
        thirtyYearApr: (_b = data["30 Year Fixed Conforming"]) == null ? void 0 : _b.apr,
        thirtyYearPoints: (_c = data["30 Year Fixed Conforming"]) == null ? void 0 : _c.pointsPaid,
        fifteenYearRate: (_d = data["15 Year Fixed Conforming"]) == null ? void 0 : _d.rate,
        fifteenYearApr: (_e = data["15 Year Fixed Conforming"]) == null ? void 0 : _e.apr,
        fifteenYearPoints: (_f = data["15 Year Fixed Conforming"]) == null ? void 0 : _f.pointsPaid,
        sevenYearArmRate: (_g = data["7/6 ARM Conforming"]) == null ? void 0 : _g.rate,
        sevenYearArmApr: (_h = data["7/6 ARM Conforming"]) == null ? void 0 : _h.apr,
        sevenYearArmPoints: (_i = data["7/6 ARM Conforming"]) == null ? void 0 : _i.pointsPaid
      };
      return transformedData;
    } catch (error) {
      console.error("Error fetching rate summary data:", error);
      return null;
    }
  }
};
export {
  RateSummaryBlock as default
};
